<template>
    <div>

        <config-main-title>
            Tipo de Bloqueio de Leito
        </config-main-title>

        <div v-if="!em_edicao">

            <div class="row mb-3">
                <div class="col col-12 col-md-6 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search" />
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <button type="button" class="btn btn-outline-success" @click="incluir ()">
                        Incluir
                    </button>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state 
                :msg="'Nenhum tipo de bloqueio de leito identificado.'" 
                icon="fas fa-search"
                :action="'Incluir'" 
                :method="incluir" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <i class="fa fa-square mr-3" :class="'text-' + dado.st_color" aria-hidden="true"></i>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span v-if="dado.fl_recorrente" class="text-muted"
                            data-toggle="tooltip" data-placement="top" title="Recorrente"> 
                            <i class="fas fa-sync"></i>
                        </span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input" 
                                :id="'ativo-' + id" 
                                v-model="dado.fl_ativo" 
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            {{ item && item.id_bloqueio_local_tipo ? '' : 'Novo' }}
                            Tipo de Bloqueio de Leito
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">

                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input
                                    label="Descrição"
                                    :validate="validate"
                                    required
                                    v-model="item.st_titulo" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-12 col-md-12">
                                <az-input
                                    label="Cor"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="[
                                        { id: 'warning', search: 'Amarelo' },   
                                        { id: 'primary', search: 'Azul' }, 
                                        { id: 'info', search: 'Azul Claro' }, 
                                        { id: 'light', search: 'Branco' }, 
                                        { id: 'success', search: 'Verde' }, 
                                        { id: 'danger', search: 'Vermelho' }, 
                                        { id: 'dark', search: 'Petro' }, 
                                    ]"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="item.st_color" />
                            </div>
                        </div>

                        <div class="d-flex flex-column mt-3" v-if="item.st_titulo && item.st_color">
                            <span class="badge" :class="'badge-' + item.st_color">
                                {{ item.st_titulo }}
                            </span>
                        </div>
                        
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="bloqueioLocalTipo" :id="item.id_bloqueio_local_tipo" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_bloqueio_local_tipo ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data () { 
        return { 
            dados: null, 
            em_edicao: false, 
            item: null, 
            validate: false,
            search: "", 
            viewMode: "A",
            title: "", 
            short_title: "", 
            service: "",
        }
    },

    props: ['cadastro'],

    components: { 
        ConfigMainTitle,
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton
    },

    computed: { 
        lista: function () { 
            let pesquisar = this.search.trim();
            let parts = pesquisar.replace(' ','.*');
            let match = parts;
            let reg = new RegExp(match, 'i');

            return this.dados && this.dados.length ? 
                this.dados.filter (item => { 
                    return ( this.viewMode == 'T' || item.fl_ativo ) && 
                        ( !this.search || reg.test(JSON.stringify(item)) );
                }) : null;
        }
    },

    methods: { 
        incluir () { 
            this.validate = false;

            let item = {
                id_bloqueio_local_tipo: null, 
                st_titulo: "", 
                st_color: "", 
                fl_ativo: true,
            };

            this.editar (item);
        },
        load () { 
            this.$store.commit('loading', true);

            let query = { q: [
                { 
                    name: 'bloqueio_local_tipos.index',
                    id: 'lista',
                    parms: { 
                        cadastro: true, 
                    },
                },
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.lista.status == 200 ) { 
                        this.dados = res.data.lista.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });
        },
        editar (item) { 
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoModal').modal('show');
        },
        atualizar () { 

            this.validate = true;

            this.$nextTick (() => { 

                let invalids = $('.invalid');

                if ( invalids.length ) { 
                   
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Verificar preenchimento dos campos.",
                        life: 3000
                    });

                } else { 

                    this.$store.commit('loading', true);

                    let query = { q: [ 
                        { 
                            name: 'bloqueio_local_tipos.store',
                            id: 'atualizar',
                            parms: { 
                                ...this.item,
                            }
                        }
                    ]};
                    
                    this.axios.post('/aql', query)
                        .then (res => { 
                            if ( res.data.atualizar.status == 200 ) { 
                                $('#edicaoModal').modal('hide');
                                this.load();

                                this.$toast.add({
                                        severity: "success",
                                        summary: "Atenção",
                                        detail: "Cadastro atualizado.",
                                        life: 3000
                                    });
                            }
                        })
                        .finally(() => { 
                            this.$store.commit('loading', false);
                        });

                }

            });

        },
        fechar () { 
            this.em_edicao = false;

            this.em_edicao = false;
            this.$store.commit('setBreadcrumb', this.breadcrumb);
        },
        toggle (item) { 

            this.$store.commit('loading', true);

            let query = { q: [ 
                { 
                    name: 'bloqueio_local_tipos.toggle',
                    id: 'toggle',
                    parms: { 
                        ...item,
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => { 
                    if ( res.data.toggle.status == 200 ) { 
                        //
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
                currencyDisplay: 'code',
            });

            return formatter.format(n).substr(4);
        },
    },

    mounted () { 
        this.load ();

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Tipo de Bloqueio de Leito", method: this.fechar },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

    },

    updated () { 
        $('[data-toggle="tooltip"]').tooltip();
    }


}
</script>